<template>
    <el-dialog
        title="新增&编辑内容"
        :visible.sync="dialogIsShow"
        width="1000px"
        :append-to-body="true"
        class="edit-strategy-dialog"
        :destroy-on-close="true"
        @open="openCallback"
        @close="closeCallback"
    >
        <div class="dialog-body">
            <el-scrollbar class="main-part">
                <el-form class="dialog-form" ref="formRef1" :model="form" label-width="100px" :rules="formRule">
                    <el-form-item label="策略名称" prop="strategyName">
                        <el-input v-model="form.strategyName" placeholder="请输入策略名称"></el-input>
                    </el-form-item>
                </el-form>
                <div class="info-box">
                    <div class="box-header">
                        <div class="title">策略命中配置</div>
                    </div>
                    <div class="box-body">
                        <el-form class="dialog-form" ref="formRef2" :model="form" label-width="100px" :rules="formRule">
                            <el-form-item label="渠道选择" prop="channelSelectionType">
                                <div>
                                    <el-radio v-model="form.channelSelectionType" :label="1">全部渠道</el-radio>
                                    <el-radio v-model="form.channelSelectionType" :label="2">指定渠道</el-radio>
                                </div>
                                <el-input v-if="form.channelSelectionType === 2" type="textarea" @focus="channelInputClick" v-model="form.channelStr"/>
                                <channel-popups :isAppendToBody="true" :modelIsAppendToBody="false" :app-id="form.channels.map(item => item.channelId).join(',')"
                                    :visible.sync="channelVisible" @comfirm="channelConfirm" :multiple="true"></channel-popups>
                            </el-form-item>
                            <el-form-item label="APK版本范围" prop="apkVersionType">
                                <div>
                                    <el-radio v-model="form.apkVersionType" :label="1">全部版本</el-radio>
                                    <el-radio v-model="form.apkVersionType" :label="2">指定版本</el-radio>
                                </div>
                                <div v-if="form.apkVersionType === 2" style="display: flex;">
                                    <el-input-number style="margin-right: 16px;" v-model="form.minApkVersion" :min="0" ></el-input-number>
                                    <el-input-number v-model="form.maxApkVersion" :min="0" ></el-input-number>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定UID" prop="specifiedUids">
                                <el-input v-model="form.specifiedUids" placeholder="多个用英文逗号隔开" type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="info-box">
                    <div class="box-header">
                        <div class="title">关联导航配置</div>
                        <el-button style="margin-left: 16px;" plain size="small" @click="addNavigationTab">添加导航</el-button>
                        <el-button style="margin-left: 16px;" plain size="small" @click="addMeetingNavigationTab">添加会议导航</el-button>
                    </div>
                    <div v-for="(item, index) in form.navigationItems" :key="index" :class="['box-body', item.navigationCategory === 2 ? 'meeting-navigation-box' : '']">
                        <el-form class="dialog-form" ref="formRef3" :model="form" label-width="120px" :rules="formRule">
                            <el-form-item label="导航背景图" prop="categoryBackgroundImageUrl">
                                <lb-img-uploader class="img-uploader" v-model="item.categoryBackgroundImageUrl" />
                            </el-form-item>
                            <el-form-item v-for="(navigationId, navigationIndex) in item.navigations" :key="navigationId" :label="`导航tab${navigationIndex + 1}`" required>
                                <div class="navigation-tab-container">
                                    <el-select v-model="item.navigations[navigationIndex]" filterable placeholder="请选择">
                                        <el-option
                                            v-for="item in navigationOptions"
                                            :key="item.id"
                                            :label="`(${item.id}) ${item.navgationTitle}`"
                                            :value="item.id"
                                            />
                                    </el-select>
                                    <el-button class="delete-button" type="text" icon="el-icon-delete" @click="deleteNavigationTab(index, navigationIndex)">删除</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <el-form class="dialog-form" ref="formRef4" :model="form" label-width="100px" :rules="formRule">
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="form.remark" placeholder="请输入备注" type="textarea" :maxlength="999"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-radio v-model="form.status" :label="1">生效</el-radio>
                        <el-radio v-model="form.status" :label="0">失效</el-radio>
                    </el-form-item>
                </el-form>
            </el-scrollbar>
            <div class="button-container">
                <el-button type="primary" @click="confirmEdit">保存</el-button>
                <el-button @click="cancelEdit">取消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import LbImgUploader from '@/components/lbImgUploader';
import ChannelPopups from "@/components/channel-popups";
import { list as navigationList } from '@/api/tv/navigation'
import { submit } from '@/api/tv/strategy'
export default {
  name: 'EditStrategyDialog',
  components: {
    LbImgUploader,
    ChannelPopups
  },
  model: {
    prop: 'dialogIsShow',
    event: 'changeDialogIsShow'
  },
  props: {
    dialogIsShow: Boolean,
    editType: {
        type: Number,
        default: 1
    },//编辑类型，1新增 2编辑
    selectStrategy: {
        type: Object,
        default: null
    },//选择的策略
    confirmCallback: {
        type: Function,
        default: ()=>{}
    },
  },
  data() {
    return {
        form: {
            strategyName: '',
            channelSelectionType: 1,
            channelStr: '',
            channels: [],
            apkVersionType: 1,
            minApkVersion: 0,
            maxApkVersion: 0,
            navigationItems: [
                {
                    navigationCategory: 1, //1导航 2会议导航
                    categoryBackgroundImageUrl: '',
                    navigations: [], //导航列表
                },
                {
                    navigationCategory: 2,
                    categoryBackgroundImageUrl: '',
                    navigations: [], //会议导航列表
                }
            ],
            specifiedUids: '',
            remark: '',
            status: 1,
        }, // 表单
        formRule: {
            strategyName: [
                { required: true, message: '请输入策略名称', trigger: 'blur' }
            ],
            channelSelectionType: [
                { required: true, message: '请选择渠道选择', trigger: 'change' }
            ],
            status: [
                { required: true, message: '请选择状态', trigger: 'change' }
            ]
        },
        navigationOptions: [], //导航选项
        channelVisible: false, //渠道选择框是否展示
        isSubmiting: false, //是否提交中
    }
  },
  computed: {
  },
  watch: {},
  methods: {
    // 点击渠道选择框
    channelInputClick() {
      this.channelVisible = true;
    },
    // 确认渠道选择
    channelConfirm($event) {
      const { appId, nameStr } = $event;
      const tempIdList = appId.split(",");
      const tempNameList = nameStr.split(",");
      this.form.channels = tempIdList.map((item, index) => {
        return {
          channelId: item,
          channelName: tempNameList[index]
        }
      });
      this.form.channelStr = tempIdList.map((item, index) => {
        return `[${item}] ${tempNameList[index]}`;
      }).join(',');
    },
    // 刷新导航选项
    async refreshNavigationOptions() {
        const {data: {data: {records}}} = await navigationList({
            current: 1,
            size: 10000,
        })
        this.navigationOptions = records
    },
    // 新增导航tab
    addNavigationTab() {
        const navigationItem = this.form.navigationItems.find(item => item.navigationCategory === 1)
        if(navigationItem) {
            navigationItem.navigations.push(null)
        }
    },
    // 添加会议导航tab
    addMeetingNavigationTab() {
        const meetingNavigationItem = this.form.navigationItems.find(item => item.navigationCategory === 2)
        if(meetingNavigationItem) {
            meetingNavigationItem.navigations.push(null)
        }
    },
    // 删除导航tab
    deleteNavigationTab(navigationItemIndex, navigationIndex) {
        this.form.navigationItems[navigationItemIndex].navigations.splice(navigationIndex, 1)
    },
    // 删除会议导航tab
    deleteMeetingNavigationTab(navigationItemIndex, navigationIndex) {
        this.form.navigationItems[navigationItemIndex].navigations.splice(navigationIndex, 1)
    },
    // 取消编辑
    cancelEdit() {
        this.$emit('changeDialogIsShow', false)
    },
    // 确认编辑
    confirmEdit() {
        this.$refs.formRef1.validate(async (valid) => {
            if (valid) {
                if(this.form.channelSelectionType === 2) {
                    if(this.form.channels.length === 0) {
                        this.$message.warning("请选择渠道")
                        return
                    }
                }
                try{
                    this.isSubmiting = true
                    const params = {
                        ...this.form
                    }
                    
                    params.navigationItems = params.navigationItems
                        .map(item => ({
                            navigationCategory: item.navigationCategory,
                            categoryBackgroundImageUrl: item.categoryBackgroundImageUrl,
                            navigations: item.navigations
                                .filter(navigationId => navigationId !== null)
                                .map((navigationId, index) => ({ navigationId, displayOrder: index + 1 }))
                        }))
                        .filter(item => item.navigations.length > 0)


                    const isNavigationItemsValid = params.navigationItems.some(item => item.navigations.length > 0)
                    
                    if(!isNavigationItemsValid) {
                        this.$message.warning("请添加导航或会议导航")
                        return
                    }

     
                    if(this.editType === 1) {
                        await submit(params)
                        this.$message.success("添加成功")
                    }else{
                        await submit({...params, id: this.selectStrategy.id})
                        this.$message.success("编辑成功")
                    }
                    this.confirmCallback()
                    this.$emit('changeDialogIsShow', false)
                }finally{
                    this.isSubmiting = false
                }
            }
        })
    },
    // 重置表单
    resetForm() {
        this.form = {
            strategyName: '',
            channelSelectionType: 1,
            channelStr: '',
            channels: [],
            apkVersionType: 1,
            minApkVersion: 0,
            maxApkVersion: 0,
            navigationItems: [
                {
                    navigationCategory: 1,
                    categoryBackgroundImageUrl: '',
                    navigations: [],
                },
                {
                    navigationCategory: 2,
                    categoryBackgroundImageUrl: '',
                    navigations: [],
                }
            ],
            specifiedUids: '',
            remark: '',
            status: 1,
        }
    },
    // 打开回调
    openCallback() {
        this.refreshNavigationOptions()
        this.resetForm()
        if(this.editType === 2) {
            const {strategyName, channelSelectionType, channels, apkVersionType, minApkVersion, maxApkVersion, navigationItems, specifiedUids, remark, status} = this.selectStrategy
            Object.assign(this.form, {
                strategyName,
                channelSelectionType,
                channels,
                apkVersionType,
                minApkVersion,
                maxApkVersion,
                specifiedUids,
                remark,
                status,
                channelStr: channels.map(item => `[${item.channelId}] ${item.channelName}`).join(',')
            })
            this.form.navigationItems.forEach(item => {
                const matchedItem = navigationItems.find(navItem => navItem.navigationCategory === item.navigationCategory)
                if (matchedItem) {
                    item.categoryBackgroundImageUrl = matchedItem.categoryBackgroundImageUrl
                    item.navigations = matchedItem.navigations.map(nav => nav.navigationId)
                }
            })  
        }
    },
    // 关闭回调
    closeCallback() {
        this.$emit('changeDialogIsShow', false)
    }
  },
  created() {},
  mounted() {}
}
</script>

<style>
.edit-strategy-dialog{
    display: flex;
    align-items: center;
    justify-content: center;
    .el-dialog{
        margin-top: unset !important;
        margin: unset !important;
    }
    .dialog-body{
        .main-part{
            height: 70vh;
            .dialog-form{
                margin: 0px auto;
                width: 80%;
            }
            .info-box{
                display: flex;
                flex-direction: column;
                margin-bottom: 16px;
                .box-header{
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    .title{
                        border-left: 4px solid #419EFF;
                        padding-left: 5px;
                    }
                }
                .box-body{
                    background-color: #F7F7F7;
                    padding: 16px;
                    border-radius: 8px;
                    margin-bottom: 16px;
                }
                .meeting-navigation-box {
                    border: 2px solid red;
                }
                .navigation-tab-container{
                    display: flex;
                    .delete-button{
                        margin-left: auto;
                        color: red;
                        &:hover{
                            color: rgb(242 156 156);
                        }
                    }
                }
            }
        }
        .button-container{
            display: flex;
            justify-content: end;
        }
    }
}

</style>